import React from 'react';
import PropTypes from 'prop-types';
import { Box } from '@eatclubapp/ec-component-library';
import { Modal } from '../../../Modal/Modal';
import { Heading } from '../../../Heading';
import { useMediaQuery, useTheme } from '@mui/material';
import useStyles, { getModalStyles } from './CreditAppliedModalStyles';
import CoinShineSVG from '../../../../assets/coin_shine.svg';

const CreditAppliedModal = ({ isOpen, onClose, creditAmount }) => {
  const classes = useStyles();
  const theme = useTheme();
  const breakpointMdDown = useMediaQuery(theme.breakpoints.down('md'));

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      hideFooter={true}
      style={getModalStyles(breakpointMdDown)}
    >
      <Box className={classes.creditAppliedModalContainer}>
        <Box className={classes.creditAppliedModalContent}>
          <Heading className={classes.creditAppliedModalTitle}>Credit applied!</Heading>
          <Box className={classes.creditAppliedModalDescription}>
            You have added {creditAmount} to your next settlement.
          </Box>
        </Box>
        {!breakpointMdDown && (
          <Box className={classes.creditAppliedModalImageContainer}>
            <CoinShineSVG className={classes.creditAppliedModalImage} />
          </Box>
        )}
      </Box>
    </Modal>
  );
};

CreditAppliedModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  creditAmount: PropTypes.string.isRequired,
};

export default CreditAppliedModal;
